import { hasLocizeTranslation } from 'lib/utils/locize'

const messages = {
  clear: ['Clear search text', 'ล้างคำค้นหา'],
  close: ['Close search', 'ปิดการค้นหา'],
  closeLabel: ['Close', 'ปิด'],
  placeholder: ['Search', 'ค้นหา'],
  open: ['Open search', 'เปิดการค้นหา'],
  unavailable: [
    'Recommendations could not load. Try again or browse the categories above.',
    'ไม่สามารถโหลดสินค้าแนะนำได้ ลองอีกครั้งหรือเลือกหมวดหมู่ด้านบน',
  ],
  empty: [
    'No recommendations right now. Try another search or browse the categories above.',
    'ยังไม่มีสินค้าแนะนำ ลองค้นหาใหม่หรือเลือกหมวดหมู่ด้านบน',
  ],
  retry: ['Try again', 'ลองอีกครั้ง'],
  retrying: ['Trying again…', 'กำลังลองอีกครั้ง…'],
}

export default (t, language, key) =>
  hasLocizeTranslation(
    t,
    `SEARCH_RECOVERY_${key.toUpperCase()}`,
    messages[key][language?.split('-')[0] === 'th' ? 1 : 0],
  )
